<template>
    <div class="header-switcher">
        <div class="header-switcher_ico">
            <i :class="getStatus.header.minimaze ? 'icon-icon-up' : 'icon-icon-down'" 
                @click="setStatusHeader"></i>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            getStatus:'usersets/getSettings'
        })
    },
    methods: {
        setStatusHeader() {
            this.$store.dispatch('usersets/saveSettingsHeaderMinimaze',!this.getStatus.header.minimaze )
        }
    }
}
</script>
<style lang="less" scoped>
.header-switcher {
    background-color: #3d536b;
    min-width: 32px;
    min-height: 88px;
    justify-content: center;
    color: #718da8;
    font-size: 18px;
    align-self: center;
    text-align: center;
    display: flex;
    align-items: center;
    margin-left: 1px;
    cursor: pointer;
    &_ico {
        margin-top: 6px;
    }
}
</style>
